module.exports = __webpack_public_path__ + "static/media/lose-loop.f9409e0f.gif";